module.exports = __webpack_public_path__ + "static/assets/e47cd5bd430206cefd3a8a5cb4af9138.png";